<template>
    <v-dialog v-model="dialog" persistent max-width="750px">
        <v-card>
            <v-card-title class="grey lighten-4">
                <strong>Cambiar Estado</strong>
                <v-spacer></v-spacer>
                <span class="caption mr-2">Cot #{{ cotizacion.id }}</span>
                <v-chip x-small :color="colorEstadoActual" text-color="white">{{ descEstadoActual }}</v-chip>
            </v-card-title>
            <v-card-text class="pt-4">
                <v-row dense align="center">
                    <v-col cols="12" sm="4">
                        <v-select
                            dense
                            v-model="selectedEstado"
                            :items="estadosDisponibles"
                            item-text="descripcion"
                            item-value="id"
                            label="Nuevo Estado"
                            outlined
                            hide-details="auto"
                        />
                    </v-col>
                    <v-col cols="12" sm="5">
                        <v-textarea
                            dense
                            outlined
                            v-model="observaciones"
                            :label="selectedEstado >= 10 ? 'Motivo *' : 'Observaciones'"
                            :placeholder="selectedEstado === 10 ? '¿Por qué se perdió?' : selectedEstado === 11 ? 'Motivo de falta de interés' : 'Notas del cambio'"
                            rows="2"
                            hide-details="auto"
                            v-validate="selectedEstado >= 10 ? 'required' : ''"
                            data-vv-name="observaciones"
                            :error-messages="errors.collect('observaciones')"
                        />
                    </v-col>
                    <v-col cols="12" sm="3" class="d-flex align-center">
                        <v-btn
                            block
                            color="primary"
                            :disabled="!selectedEstado"
                            :loading="loading"
                            @click="confirmar"
                        >
                            ENVIAR
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row dense class="mt-4">
                    <v-col cols="12">
                        <v-divider></v-divider>
                        <div class="py-2 caption grey--text text--darken-1">HISTORIAL DE CAMBIOS</div>
                        <v-simple-table dense v-if="historial.length">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="caption">Estado</th>
                                        <th class="caption">Usuario</th>
                                        <th class="caption">Observaciones</th>
                                        <th class="caption">Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="h in historial" :key="h.id">
                                        <td class="body-2">{{ h.descEstado }}</td>
                                        <td class="caption">{{ h.usuario }}</td>
                                        <td class="caption">{{ h.observaciones || '—' }}</td>
                                        <td class="caption">{{ h.created_at }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        <div v-else class="caption grey--text pa-2">Sin cambios registrados</div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="grey lighten-5">
                <v-spacer></v-spacer>
                <v-btn text @click="cerrar">CERRAR</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    props: {
        open: { type: Boolean, default: false },
        cotizacion: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            loading: false,
            selectedEstado: null,
            observaciones: '',
            historial: []
        }
    },
    computed: {
        ...mapGetters('cotizaciones', ['estadosCotizacion']),
        dialog: {
            get() { return this.open },
            set() {}
        },
        descEstadoActual() {
            if (!this.cotizacion.idEstado) return 'Sin estado'
            const found = this.estadosCotizacion.find(e => e.id === this.cotizacion.idEstado)
            return found ? found.descripcion : 'Sin estado'
        },
        colorEstadoActual() {
            if (!this.cotizacion.idEstado) return 'grey'
            if (this.cotizacion.idEstado === 9) return 'green'
            if (this.cotizacion.idEstado >= 10) return 'red'
            return 'primary'
        },
        estadosDisponibles() {
            return this.estadosCotizacion.filter(e => e.id !== this.cotizacion.idEstado)
        }
    },
    methods: {
        cerrar() {
            this.$emit('close')
        },
        async confirmar() {
            const needsReason = this.selectedEstado >= 10
            if (needsReason) {
                const valid = await this.$validator.validateAll()
                if (!valid) return
            }
            this.loading = true
            this.$emit('confirm', {
                id: this.cotizacion.id,
                idEstado: this.selectedEstado,
                observaciones: this.observaciones
            })
        },
        async loadHistorial() {
            const id = this.cotizacion.id
            if (!id) return
            try {
                const { data } = await request({
                    url: `/api-loopback/tb_cotizaciones/${id}/historialEstados`,
                    method: 'GET'
                })
                this.historial = data.historial || data || []
            } catch (e) {
                this.historial = []
            }
        },
        reset() {
            this.selectedEstado = null
            this.observaciones = ''
            this.historial = []
            this.$validator.reset()
            this.loading = false
        },
        onEstadoChanged() {
            this.loading = false
            this.selectedEstado = null
            this.observaciones = ''
            this.$validator.reset()
            this.loadHistorial()
        }
    },
    watch: {
        open(val) {
            if (val) {
                this.reset()
                this.loadHistorial()
            }
        }
    }
}
</script>
